export enum BulkRewardEvents {
  DownloadCsvTemplate = "download_csv_template",
  UploadCsv = "upload_csv",
  CsvFormatError = "csv_format_error",
  UserMatchError = "user_match_error",
  SendReward = "send_reward"
}
